export function Ellipsis({ text, width, lineClamp = 3 }: { text: string, width: number, lineClamp?: number }) {
    const isUrl = text.startsWith("http") || text.startsWith("/");

    return <div
        style={{
            display: "-webkit-box",
            maxWidth: `${width}px`,
            overflow: "hidden",
            lineClamp: lineClamp,
            WebkitLineClamp: lineClamp,
            WebkitBoxOrient: "vertical",
        }}
        title={text}
    >
        {isUrl && <a href={text} target="_blank" rel="noreferrer">{text}</a>}
        {!isUrl && text}
    </div>;
}
